import createIcon from '../../createIcon';

/**
 * @component @name FilterAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC4yNTQ1NyA1LjYxQzYuMjc0NTcgOC4yIDEwLjAwNDYgMTMgMTAuMDA0NiAxM1YxOUMxMC4wMDQ2IDE5LjU1IDEwLjQ1NDYgMjAgMTEuMDA0NiAyMEgxMy4wMDQ2QzEzLjU1NDYgMjAgMTQuMDA0NiAxOS41NSAxNC4wMDQ2IDE5VjEzQzE0LjAwNDYgMTMgMTcuNzI0NiA4LjIgMTkuNzQ0NiA1LjYxQzIwLjI1NDYgNC45NSAxOS43ODQ2IDQgMTguOTU0NiA0SDUuMDQ0NTdDNC4yMTQ1NyA0IDMuNzQ0NTcgNC45NSA0LjI1NDU3IDUuNjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FilterAlt = createIcon('FilterAlt', [
  [
    'path',
    {
      d: 'M4.25457 5.61C6.27457 8.2 10.0046 13 10.0046 13V19C10.0046 19.55 10.4546 20 11.0046 20H13.0046C13.5546 20 14.0046 19.55 14.0046 19V13C14.0046 13 17.7246 8.2 19.7446 5.61C20.2546 4.95 19.7846 4 18.9546 4H5.04457C4.21457 4 3.74457 4.95 4.25457 5.61Z',
      key: '1f2fxi',
    },
  ],
]);

export default FilterAlt;
